import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;

  & > div:last-child {
    display: flex;

    & > div:first-child {
      .ant-btn-text {
        color: ${({ theme }) => theme.colors.tone.red};
      }
    }

    & > div:not(:last-child) {
      margin-right: 8px;
    }
  }
`;

export const MainWrapper = styled.div`
  .ant-form-item {
    width: 288px;
  }

  & > div:nth-child(2) {
    margin-bottom: 24px;
  }
`;

export const StyledSwitchButton = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px !important;

  & > button {
    margin-right: 8px;
  }
`;
